import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField } from '@mui/material';

// "Video call #48", "#48" or "48": the number in a support email is the booking's (D-103).
export function videoCallNumberOf(text) {
  const match = String(text || '').trim().match(/^(?:video\s*call\s*)?#?\s*(\d{1,9})$/i);
  return match && Number(match[1]) > 0 ? Number(match[1]) : null;
}

/** Opens a video booking from the number staff were given (admin panel plan RPT-32). */
export default function VideoLookup({ from = null }) {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const number = videoCallNumberOf(text);

  const open = (event) => {
    event.preventDefault();
    if (number) navigate(`/video-bookings/${number}`, from ? { state: { from } } : undefined);
  };

  return (
    <Box component="form" onSubmit={open} sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 2 }}>
      <TextField
        size="small"
        label="Video call #"
        placeholder="Video call #48"
        value={text}
        onChange={(event) => setText(event.target.value)}
        error={Boolean(text) && !number}
        helperText={text && !number ? 'A booking number, like 48 or #48' : ' '}
        inputProps={{ 'aria-label': 'Video call number' }}
      />
      <Button type="submit" variant="outlined" disabled={!number} sx={{ mb: 2.5 }}>Open</Button>
    </Box>
  );
}
